import { Navigate, Route, Routes } from 'react-router-dom'

import InterpretationPage from './pages/Interpretation'
import LoginPage from './pages/Login'
import StudyImagesPage from './pages/StudyImages'
import StudyInformationPage from './pages/StudyInformation'
import StudyReportPage from './pages/StudyReport'
import ActivityReportPage from './pages/ActivityReport'
import TranscriptionReportPage from './pages/TranscriptionReport'
import ReportViewPage from './pages/ReportView'
import ReferenceDataPage from './pages/ReferenceData'
import WorklistPage from './pages/Worklist'
import WorksheetPage from './pages/Worksheet'
import { AuthProvider, RequireAuth } from './lib/auth'

// Routes follow the legacy navigation path:
//   Login.aspx -> default.aspx -> MainStudyList.aspx
//              -> StudyInformation.aspx -> StudyReport.aspx
// `default.aspx` only did `Response.Redirect("MainStudyList.aspx")`, so the
// worklist is the signed-in landing page directly.
export default function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/*"
          element={
            <RequireAuth>
              <Shell />
            </RequireAuth>
          }
        />
      </Routes>
    </AuthProvider>
  )
}

// There is no application bar, because CardioReportManager has none: every page
// draws its own navigation strip, and the strip is a list of ways *out* of that
// page rather than a menu of the whole system (DEC-023). The shell is therefore
// only the routing table and the footer — see `components/PageNav.tsx` for the
// header each page renders for itself.
function Shell() {
  return (
    <>
      <Routes>
        <Route path="/" element={<WorklistPage />} />
        <Route path="/studies/:studyId" element={<StudyInformationPage />} />
        <Route path="/studies/:studyId/report" element={<StudyReportPage />} />
        <Route path="/studies/:studyId/report/view" element={<ReportViewPage />} />
        <Route path="/studies/:studyId/worksheet/:modality" element={<WorksheetPage />} />
        {/* `MainStudyList.aspx.vb:539-548` — where a transcriptionist's Open
            lands. `app/domain/study/routing.py` produces exactly this path. */}
        <Route path="/studies/:studyId/interpretation/:form" element={<InterpretationPage />} />
        <Route path="/reference" element={<ReferenceDataPage />} />
        <Route path="/activity" element={<ActivityReportPage />} />
        {/* `MainStudyList.aspx.vb:720` — the second reports link, which goes to
            `ActivityReportTranscriptionAudit.aspx`. */}
        <Route path="/activity/transcription" element={<TranscriptionReportPage />} />
        {/* `VerifyLocation.aspx` — the worklist's View Online command, whose own
            redirect is commented out at `MainStudyList.aspx.vb:597`. */}
        <Route path="/studies/:studyId/images" element={<StudyImagesPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>

      <footer className="appfooter">
        Copyright © 2005 Cardiac Information Services, Inc. ALL RIGHTS RESERVED.
      </footer>
    </>
  )
}
